import { GameServices } from '../../services/game-services';
import { TwentyOneAssetType } from '../../model/twentyone-types';
import { TwentyOne } from 'game-logic';

export class ChevronHintViewModel {
  public get chevronAsset() {
    return this.gameServices.assetCatalogueService.getAsset(TwentyOneAssetType.Chevron);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }

  constructor(
    private gameServices: GameServices,
    public readonly columnId: TwentyOne.PileId,
  ) {}

  public resetGameScene() {
    // TODO: Probably hide things
  }
}
